import "./Contact.module.css";
import MainNavigation from "@/reusable_sections/Header";
import StartYourRevenueJourney from "./sections/StartYourRevenueJourney";
import GlobalExpertiseLocalFocus from "./sections/GlobalExpertiseLocalFocus";
import FooterInformation from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <MainNavigation />
      <GlobalExpertiseLocalFocus />
      <StartYourRevenueJourney />
      <FooterInformation />
    </div>;
}